function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequire37b7"];
parcelRequire.register("9MKJ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71fcd7b7ec906232$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $5YM7L = parcelRequire("5YM7L");

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $aA6j8 = parcelRequire("aA6j8");

var $jPJEp = parcelRequire("jPJEp");

var $6A0cm = parcelRequire("6A0cm");

var $jHZOR = parcelRequire("jHZOR");

var $erZ2i = parcelRequire("erZ2i");
var $8iz5R = parcelRequire("8iz5R");

var $sw8Qy = parcelRequire("sw8Qy");

var $fFuU3 = parcelRequire("fFuU3");

var $lLIDD = parcelRequire("lLIDD");

var $6e88g = parcelRequire("6e88g");

var $3mKzC = parcelRequire("3mKzC");

var $kNWHq = parcelRequire("kNWHq");

var $3Ksyi = parcelRequire("3Ksyi");

var $laF4l = parcelRequire("laF4l");

var $jPYSb = parcelRequire("jPYSb");
function $71fcd7b7ec906232$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $71fcd7b7ec906232$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $71fcd7b7ec906232$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $71fcd7b7ec906232$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $71fcd7b7ec906232$var$tooltipZIndex = (0, $6e88g.layers).tooltip();
var $71fcd7b7ec906232$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "18.1.2"
};
// Inverts motion direction
var $71fcd7b7ec906232$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param position - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $71fcd7b7ec906232$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
function $71fcd7b7ec906232$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $laF4l.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $6A0cm.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $6A0cm.default) : _ref$onHide, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $jPJEp.usePlatformLeafSyntheticEventHandler)($71fcd7b7ec906232$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $71fcd7b7ec906232$var$analyticsAttributes));
    var onHideHandler = (0, $jPJEp.usePlatformLeafSyntheticEventHandler)($71fcd7b7ec906232$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $71fcd7b7ec906232$var$analyticsAttributes));
    var apiRef = (0, $91i6m.useRef)(null);
    var _useState = (0, $91i6m.useState)("hide"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $91i6m.useRef)(null);
    var containerRef = (0, $91i6m.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $91i6m.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var lastState = (0, $91i6m.useRef)(state);
    var lastDelay = (0, $91i6m.useRef)(delay);
    var lastHandlers = (0, $91i6m.useRef)({
        onShowHandler: onShowHandler,
        onHideHandler: onHideHandler
    });
    var hasCalledShowHandler = (0, $91i6m.useRef)(false);
    (0, $91i6m.useEffect)(function() {
        lastState.current = state;
        lastDelay.current = delay;
        lastHandlers.current = {
            onShowHandler: onShowHandler,
            onHideHandler: onHideHandler
        };
    }, [
        delay,
        onHideHandler,
        onShowHandler,
        state
    ]);
    var start = (0, $91i6m.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $91i6m.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, []);
    var abort = (0, $91i6m.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
    }, []);
    (0, $91i6m.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $91i6m.useRef)(false);
    (0, $91i6m.useEffect)(function() {
        return (0, $3mKzC.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var showTooltip = (0, $91i6m.useCallback)(function(source) {
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // Tell the tooltip to keep showing
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        var entry = {
            source: source,
            delay: lastDelay.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    lastHandlers.current.onShowHandler();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $kNWHq.show)(entry);
        start(api);
    }, [
        abort,
        done,
        start
    ]);
    var hideTooltipOnEsc = (0, $91i6m.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $jHZOR.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $91i6m.useEffect)(function() {
        if (state === "hide") return 0, $6A0cm.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $aA6j8.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $91i6m.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $91i6m.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $91i6m.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $jPYSb.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        showTooltip(source);
    }, [
        position,
        showTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $91i6m.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $jPYSb.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $91i6m.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $91i6m.useCallback)(function() {
        showTooltip({
            type: "keyboard"
        });
    }, [
        showTooltip
    ]);
    var onBlur = (0, $91i6m.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $91i6m.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && lastState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, []);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipContainer = state !== "hide" && Boolean(content);
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === "mouse" && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipId = (0, $3Ksyi.default)("tooltip", shouldRenderTooltipContainer);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    (0, $91i6m.useEffect)(function() {
        // If there is no container element, we should exit early, because that
        // means they are using the render prop API, and that is implemented in a
        // different way. If there is no target element yet or tooltipId, we also
        // shouldn't do anything because there is nothing to operate on or with.
        if (!containerRef.current || !targetRef.current || !tooltipId) return;
        var target = targetRef.current;
        if (shouldRenderTooltipContainer) target.setAttribute("aria-describedby", tooltipId);
        else target.removeAttribute("aria-describedby");
    }, [
        shouldRenderTooltipContainer,
        tooltipId
    ]);
    var hiddenContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipId
    }, typeof content === "function" ? content({}) : content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, children($71fcd7b7ec906232$var$_objectSpread($71fcd7b7ec906232$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipId,
        ref: setDirectRef
    })), shouldRenderTooltipContainer && hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, shouldRenderTooltipContainer && hiddenContent), shouldRenderTooltipContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $lLIDD.default), {
        zIndex: $71fcd7b7ec906232$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $fFuU3.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $71fcd7b7ec906232$var$invertedDirection[$71fcd7b7ec906232$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $erZ2i.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $8iz5R.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state === "show-immediate" ? 0 : (0, $sw8Qy.mediumDurationMs)
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: style,
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$71fcd7b7ec906232$var$Tooltip.displayName = "Tooltip";
var $71fcd7b7ec906232$export$2e2bcd8739ae039 = $71fcd7b7ec906232$var$Tooltip;

});
parcelRequire.register("jPJEp", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $e706310e4813263a$export$1a04351537078b55; });

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $8Xa2x = parcelRequire("8Xa2x");

var $2R3rH = parcelRequire("2R3rH");
function $e706310e4813263a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e706310e4813263a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e706310e4813263a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e706310e4813263a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e706310e4813263a$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $8Xa2x.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $2R3rH.useTrackedRef)(analyticsData);
    var fnRef = (0, $2R3rH.useTrackedRef)(fn);
    var handler = (0, $91i6m.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $e706310e4813263a$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRequire.register("jHZOR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e591fc7dd0cdefc3$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $aA6j8 = parcelRequire("aA6j8");

var $lyJnu = parcelRequire("lyJnu");
function $e591fc7dd0cdefc3$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $91i6m.useRef)(false);
    var onKeyDown = (0, $91i6m.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $lyJnu.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $91i6m.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $91i6m.useEffect)(function() {
        return (0, $aA6j8.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
parcelRequire.register("lyJnu", function(module, exports) {

$parcel$export(module.exports, "ESCAPE", function () { return $fb1ff9104554a579$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $fb1ff9104554a579$export$390330c10ff2b9a1 = "ArrowUp";
var $fb1ff9104554a579$export$a80636c6f41931fe = "ArrowDown";
var $fb1ff9104554a579$export$4af703091671bc = "Home";
var $fb1ff9104554a579$export$e2bc30913faa5db7 = "End";
var $fb1ff9104554a579$export$2bb790b9008907b4 = "Escape";

});


parcelRequire.register("3mKzC", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $27378db06f5c3f95$export$6503ec6e8aabbaf; });
/**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $aA6j8 = parcelRequire("aA6j8");
var $27378db06f5c3f95$var$registrations = new Set();
var $27378db06f5c3f95$var$cleanupEndEventListeners = null;
function $27378db06f5c3f95$var$onDragStart() {
    if ($27378db06f5c3f95$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $27378db06f5c3f95$var$cleanupEndEventListeners = (0, $aA6j8.bindAll)(window, [
        {
            type: "dragend",
            listener: $27378db06f5c3f95$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $27378db06f5c3f95$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $27378db06f5c3f95$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($27378db06f5c3f95$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $27378db06f5c3f95$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $27378db06f5c3f95$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $27378db06f5c3f95$var$cleanupEndEventListeners = null;
    var clone = Array.from($27378db06f5c3f95$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $27378db06f5c3f95$var$bindStartEvents() {
    return (0, $aA6j8.bindAll)(window, [
        {
            type: "dragstart",
            listener: $27378db06f5c3f95$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $27378db06f5c3f95$var$onDragStart
        }
    ]);
}
var $27378db06f5c3f95$var$cleanupStartEventListeners = null;
function $27378db06f5c3f95$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$27378db06f5c3f95$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $27378db06f5c3f95$var$cleanupStartEventListeners = $27378db06f5c3f95$var$bindStartEvents();
    $27378db06f5c3f95$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $27378db06f5c3f95$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $27378db06f5c3f95$var$registrations.delete(registration);
        if ($27378db06f5c3f95$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $27378db06f5c3f95$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $27378db06f5c3f95$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRequire.register("kNWHq", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $f255eab6fb748286$export$57bf213be019eeb0; });

var $hYYH8 = parcelRequire("hYYH8");
// This file is a singleton for managing tooltips
var $f255eab6fb748286$var$active = null;
function $f255eab6fb748286$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($f255eab6fb748286$var$active && $f255eab6fb748286$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $hYYH8.clearScheduled)();
            $f255eab6fb748286$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $hYYH8.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $hYYH8.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $hYYH8.scheduleTimeout)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($f255eab6fb748286$var$active && $f255eab6fb748286$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($f255eab6fb748286$var$active) {
            (0, $hYYH8.clearScheduled)();
            $f255eab6fb748286$var$active.entry.hide({
                isImmediate: true
            });
            $f255eab6fb748286$var$active.entry.done();
            $f255eab6fb748286$var$active = null;
        }
        // this tooltip is now the active tooltip
        $f255eab6fb748286$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $hYYH8.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRequire.register("hYYH8", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", function () { return $d1771efb1fbfe83d$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $d1771efb1fbfe83d$export$5f4d6617421d489b; });
var $d1771efb1fbfe83d$var$delayId = null;
function $d1771efb1fbfe83d$export$eaf678f6f93f5250() {
    if ($d1771efb1fbfe83d$var$delayId != null) {
        window.clearTimeout($d1771efb1fbfe83d$var$delayId);
        $d1771efb1fbfe83d$var$delayId = null;
    }
}
function $d1771efb1fbfe83d$export$5f4d6617421d489b(fn, delay) {
    $d1771efb1fbfe83d$export$eaf678f6f93f5250();
    $d1771efb1fbfe83d$var$delayId = window.setTimeout(function() {
        $d1771efb1fbfe83d$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRequire.register("3Ksyi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2babd0d632bf3e35$export$2e2bcd8739ae039; });

var $aTAfv = parcelRequire("aTAfv");
function $2babd0d632bf3e35$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $aTAfv.useUIDSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});

parcelRequire.register("laF4l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f69a639a7e8917a4$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $91i6m = parcelRequire("91i6m");

var $lPOF7 = parcelRequire("lPOF7");

var $kLNLK = parcelRequire("kLNLK");

var $lSsPH = parcelRequire("lSsPH");
var $f69a639a7e8917a4$var$baseStyles = (0, $lPOF7.css)({
    boxSizing: "border-box",
    maxWidth: "240px",
    padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)"),
    insetBlockStart: "var(--ds-space-0, 0px)",
    insetInlineStart: "var(--ds-space-0, 0px)",
    borderRadius: "var(--ds-border-radius, 3px)",
    fontSize: "var(--ds-font-size-075, 12px)",
    lineHeight: 1.3,
    overflowWrap: "break-word",
    wordWrap: "break-word",
    backgroundColor: "var(--ds-background-neutral-bold, ".concat((0, $kLNLK.N800), ")"),
    color: "var(--ds-text-inverse, ".concat((0, $kLNLK.N0), ")")
});
var $f69a639a7e8917a4$var$truncateStyles = (0, $lPOF7.css)({
    maxWidth: "420px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $f69a639a7e8917a4$var$TooltipContainer = /*#__PURE__*/ (0, $91i6m.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return (0, $lPOF7.jsx)((0, $lSsPH.default), {
        ref: ref,
        style: style,
        className: className,
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: [
            $f69a639a7e8917a4$var$baseStyles,
            truncate ? $f69a639a7e8917a4$var$truncateStyles : null
        ]
    }, children);
});
$f69a639a7e8917a4$var$TooltipContainer.displayName = "TooltipContainer";
var $f69a639a7e8917a4$export$2e2bcd8739ae039 = $f69a639a7e8917a4$var$TooltipContainer;

});
parcelRequire.register("lSsPH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fed501becbcb6ca9$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $lPOF7 = parcelRequire("lPOF7");

var $6e88g = parcelRequire("6e88g");
function $fed501becbcb6ca9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fed501becbcb6ca9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fed501becbcb6ca9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fed501becbcb6ca9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fed501becbcb6ca9$var$VAR_PRIMITIVE_ZINDEX = "tooltipPrimitiveZindex";
var $fed501becbcb6ca9$var$primitiveStyles = (0, $lPOF7.css)({
    zindex: "var(".concat($fed501becbcb6ca9$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
var $fed501becbcb6ca9$var$TooltipPrimitive = /*#__PURE__*/ (0, $91i6m.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $fed501becbcb6ca9$var$_objectSpread($fed501becbcb6ca9$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, $fed501becbcb6ca9$var$VAR_PRIMITIVE_ZINDEX, (0, $6e88g.layers).tooltip()));
    return (0, $lPOF7.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $lPOF7.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $fed501becbcb6ca9$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$fed501becbcb6ca9$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $fed501becbcb6ca9$export$2e2bcd8739ae039 = $fed501becbcb6ca9$var$TooltipPrimitive;

});


parcelRequire.register("jPYSb", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", function () { return $e711ffd9463d5528$export$642213d516a9b928; });
function $e711ffd9463d5528$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});



//# sourceMappingURL=SignupPage.3eb07628.js.map
